export default function formatCep(value: string): string {
  return value?.replace(/(\d{5})(\d{3})/, '$1-$2');
}
